import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "So I bought a GoPro ...",
  "description": "",
  "published": "2013-07-17T00:00:00.000Z",
  "redirect_from": ["/blog/so-i-bought-a-gopro/swizec/6282"],
  "categories": "Camera, Cameras and Camcorders, GoPro, Photography, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`... and these things are magic.`}</p>
    <p>{`If there's anything that says `}<em parentName="p">{`"You live in the future, man"`}</em>{`, it's a camera half the size of your `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mouse_%28computing%29",
        "title": "Mouse (computing)"
      }}>{`computer mouse`}</a>{` making video at resolutions almost unheard of five years ago.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/ipPiZUozRumDCtwLGST0",
        "alt": "GoPro compared to a mouse",
        "title": "GoPro compared to a mouse"
      }}></img><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img></p>
    <p>{`Ever since the HD Hero came out in 2010, I've wanted one. No idea what I'd use it for, but it seemed `}<em parentName="p">{`so cool`}</em>{`. All those action shots of professional athletes flooding the internets whetted my appetite.`}</p>
    <p>{`And now it's mine. It's finally mine! Mwahahaha.`}</p>
    <p>{`As a responsible adult I waited for the right moment to buy the new toy. They aren't expensive, but at $300 for the mid-range version, they aren't super cheap either. Of course, in Slovenia the same package costs about 400 euro, so currently being in the US helped a lot.`}</p>
    <p>{`I bought the GoPro for two reasons:`}</p>
    <ol>
      <li parentName="ol">{`I wanted to take cool shots of last Sunday's paintball game between everyone at `}<a parentName="li" {...{
          "href": "http://www.dwellers.com/"
        }}>{`Dwellers`}</a>{`. But I didn't because there was nowhere to mount the camera.`}</li>
      <li parentName="ol">{`August Longboard Roadtrip. Need I say more?`}</li>
    </ol>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/DzshyNYLTSuLpbogx4Pz",
        "alt": "GoPro in the case",
        "title": "GoPro in the case"
      }}></img></p>
    <p>{`After a few days I couldn't take it anymore.`}</p>
    <p>{`Stuck a mount on my helmet, connected my phone to the camera, and went for a cruise around Stanford and `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.4541666667,-122.178611111&spn=0.1,0.1&q=37.4541666667,-122.178611111%20(Menlo%20Park%2C%20California)&t=h",
        "title": "Menlo Park, California"
      }}>{`Menlo Park`}</a>{` to "make a video of the area for my friends and family back home". Bollocks, just wanted to play with the toy!`}</p>
    <p>{`But the video turned out great. If way too long.`}</p>
    <p>{`It was dusky when I went out, but the 170 degree angle and fancy camera settings I will never understand made the video even brighter than reality. Since when don't cameras need obscene amounts of light to make quality video anymore?`}</p>
    <p>{`Despite its size the camera feels surprisingly heavy on the helmet. Then again, it `}<em parentName="p">{`is`}</em>{` encased in a waterproof shell that will withstand practically any impact you throw at it. `}<em parentName="p">{`And`}</em>{` you can still click all the buttons!`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/MF5hp8fvTr6LEmBL7QzR",
        "alt": "GoPro case",
        "title": "GoPro case"
      }}></img></p>
    <p>{`But my favorite feature is the wi-fi. The GoPro can create a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Hotspot_%28Wi-Fi%29",
        "title": "Hotspot (Wi-Fi)"
      }}>{`wi-fi hotspot`}</a>{` that you connect to with your phone and use an app to control the camera.`}</p>
    <p>{`You can see the preview - there's even a delay that makes it useful when the camera is on your head - turn on recording, adjust all the strange settings and turn the camera on and off.`}</p>
    <p>{`There's even a feature that makes the camera beep so you can find it when it jumps off your head and into some bushes after a gnarly crash.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/H01uRWFvQOCiZcwVOCmX",
        "alt": "in-app camera preview",
        "title": "in-app camera preview"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/kSkBnDGSueVlvYfWbXrg",
        "alt": "App mode switching",
        "title": "App mode switching"
      }}></img></p>
    <p>{`You don't want to see the two videos I made of Stanford, they're long and boring, so here's a video of me falling on a hill near `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.403,-122.149&spn=0.01,0.01&q=37.403,-122.149%20(PARC%20%28company%29)&t=h",
        "title": "PARC (company)"
      }}>{`Xerox Parc`}</a>{` and chasing the longboard down the hill when it ran away.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0b0c9eda-ad42-4f5a-8688-318ce1f84f3e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      